// extracted by mini-css-extract-plugin
export default {"documentLink":"DocumentRow_documentLink__3cARX","documentImportant":"DocumentRow_documentImportant__t3cjK"};